import React from 'react';
import { WorkingStyle, WorkingStyleGridLegend } from '../../types';
import WorkingStylesRow from '../WorkingStyleRow';
import WorkStylesLegend from '../WorkStylesLegend';

interface WorkingStylesGridProps {
  data: WorkingStyle[];
  legend?: WorkingStyleGridLegend[];
  isEditable?: boolean;
  editData?: React.Dispatch<React.SetStateAction<WorkingStyle[]>>;
}

const WorkingStylesGrid = ({
  data,
  legend,
  isEditable = false,
  editData,
}: WorkingStylesGridProps) => {
  const handleEditGrid = (row: WorkingStyle) => {
    const newData = data?.map(el => {
      if (el.traitName === row.traitName) {
        return row;
      }
      return el;
    });

    editData?.(newData);
  };

  return (
    <div>
      {legend && <WorkStylesLegend legend={legend} />}
      <div className="tw-w-full">
        {data
          .filter(el => el.traitName)
          ?.map((rowData, index) => (
            <WorkingStylesRow
              key={rowData?.traitName}
              data={rowData}
              hasTopLegend={index === 0}
              isEditable={isEditable}
              editRow={handleEditGrid}
              index={index}
            />
          ))}
      </div>
    </div>
  );
};

export default WorkingStylesGrid;
